// extracted by mini-css-extract-plugin
export default {"profile__nav":"language_profile__nav__g1bWw","savebtn_box":"language_savebtn_box__3Rwsj","updown__icon":"language_updown__icon__Jb31u","input__box":"language_input__box__CyjMA"};